<template>
	<div>
		<Tou></Tou>
		<div class="userProfilebox">
			<div class="userProfile">{{ $qu('kouling') }}
				<div class="userProfile-bg w100"></div>
				<div class="userProfile-Solarland bj-0  pt-56 pb-57 flex j-between br-10 of-hidden">
					<div class="flex ml-66 a-center ">
						<div class="tit-36"
							style="width:1rem;height:1rem;border-radius: 50%;text-align: center;color: white;line-height: 1rem;"
							:style="shu.id && colorzu1? { background: `linear-gradient(135deg, ${colorzu[0]}, ${colorzu[1]})`}:{ background: `#fff`}">
							<!-- <img style="width:1rem;height:1rem;border-radius: 50%;"
								:src="shu.avatar"> -->
							<i v-if="shu.nickname">{{getFirstLetter(shu.nickname)}}</i>
							<i v-else>{{getFirstLetter(shu.account)}}</i>

						</div>
						<div class="pl-39">
							<div class="tit-22 ys-33 userProfile-Solarlandtou montserRegular">
								<i v-if="shu.nickname">{{ shu.nickname }}</i>
								<i v-else>{{ shu.account }}</i>
							</div>
							<!-- <div style="">{{shu.roleName}}</div> -->
							<el-tag size="small" class="br-10 f-12  mr-7 mt-10" style="color: #ff0000;" type="danger"
								color="#FCE4E6">
								<i v-if="shu.roleIdentification">{{shu.roleIdentification}}</i>
								<i v-else>{{shu.roleName}}</i>
							</el-tag>
							<!-- <div class="tit-16 pt-14 userProfile-Solarlandtou2" style="color: #545454;" v-if="shu.isPlus">Country:{{ shu.country }}</div> -->
						</div>
					</div>
					<div class="flex a-center pr-82 numInfo">
						<div class="pr-39 pl-52 cur_pointer">
							<div class="tit-34 Arial B-700 ys-33 Pointss t-center a-center cur_pointer"
								@click="zhangshi(4)">{{ shu.pointNum }}</div>
							<div class="tit-16 B-300 t-center a-center" style="color:#9a9a9a;">
								{{gudingziduan.Personal.points}}</div>
						</div>
						<el-divider class="userProfenge" direction="vertical"></el-divider>
						<div class="pr-39 pl-52 cur_pointer" @click="zhangshi(2)">
							<div class="tit-34 Arial B-700 ys-33 Pointss t-center a-center">{{shu.postNum}}</div>
							<div class="tit-16 B-300 ys-33 t-center a-center" style="color:#9a9a9a;">
								{{gudingziduan.Personal.Posts}}</div>
						</div>
						<el-divider class="userProfenge" direction="vertical"></el-divider>
						<div class="pr-39 pl-52 cur_pointer" @click="zhangshi(8)">
							<div class="tit-34 Arial B-700 ys-33 Pointss t-center a-center">{{shu.pickNum}}</div>
							<div class="tit-16 B-300 ys-33  t-center a-center"
								style="white-space:nowrap;color:#9a9a9a;">{{gudingziduan.Personal.MyPicks}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="userProfilecontant flex j-between">
				<div class="userProfile-leift">
					<div class="userProfile-leift-centen pl-28 pr-27 bj-0  pt-61 pb-20  br-10">
						<div class="userProfile-leift-cententitle tit-28 ys-33 B-500 pb-46 montserMedium"
							style=" white-space: nowrap">Personal Center</div>
						<ul>
							<li class="pt-18 pb-18 flex j-between pl-24 pr-31 mb-16 cur_pointer" @click="xuannew(k)"
								v-for="(l, k) in gudingziduan.Personal.zuolies" :class="menuindex == k ? 'active' : ''">
								<div class="tit-18" :class="menuindex == k ? 'zi-E50012' : 'ys-66'">
									<span class="iconfont icon-jianjie tit-20"
										:class="menuindex == k ? 'zi-E50012' : 'ys-66'" v-if="k == 0"></span>
									<span class="iconfont icon-xiaoxi tit-20"
										:class="menuindex == k ? 'zi-E50012' : 'ys-66'" v-if="k == 1"></span>
									<span class="iconfont icon-bianxie tit-20"
										:class="menuindex == k ? 'zi-E50012' : 'ys-66'" v-if="k == 2"></span>
									<span class="iconfont icon-chanpinguanli tit-20"
										:class="menuindex == k ? 'zi-E50012' : 'ys-66'" v-if="k == 3"></span>
									<span class="iconfont icon-31jifen tit-20"
										:class="menuindex == k ? 'zi-E50012' : 'ys-66'" v-if="k == 4"></span>
									{{ l }}
								</div>
								<div class="iconfont icon-jinru1 tit-18"
									:class="menuindex == k ? 'zi-E50012' : 'ys-66'">
								</div>
							</li>
							<div style="width: 100%;display: flex;justify-content: center;">
								<div @click="tuichudenglu"
									class="userProfile-right-btn3 more1 tit-17 ys-33 B-300 cur_pointer"><span
										class="iconfont icon-fanhui mr-8"></span>Sign Out</div>

							</div>
						</ul>
					</div>
				</div>
				<div class="userProfile-right bj-0 br-10 pt-39 pb-52">
					<userprofile v-if="menuindex == 0" :usersshu="shu"></userprofile>
					<userNotification v-if="menuindex == 1" :usersshu="shu"></userNotification>
					<userreplies v-if="menuindex == 2" :usersshu="shu" :likeindex="likeindex"></userreplies>
					<userwebinar v-if="menuindex == 3" :usersshu="shu"></userwebinar>
					<userpoints v-if="menuindex == 4" :usersshu="shu"></userpoints>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import {
		allUser,
		logout
	} from '@/api/user.js';
	import {
		myxiangqing
	} from '@/api/Personal.js';

	import Tou from '../../../zuzuzu/touss.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import userNotification from '../../../zuzuzu/user-Notification.vue'
	import userpoints from '../../../zuzuzu/user-points.vue'
	import userprofile from '../../../zuzuzu/user-profile.vue'
	import userreplies from '../../../zuzuzu/user-replies.vue'
	import userwebinar from '../../../zuzuzu/user-webinar.vue'
	export default {
		data() {
			return {
				lies: ["Profile", "Notification", "Posts", "Webinar", "My points"],
				shu: {
					'nickname': '',
					'country': ''
				},
				menuindex: 0,
				likeindex: 0,
				ptype: -1,
				colorzu: [],
				colorzu1: '',
				gudingziduan: {}
			}
		},
		components: {
			Tou,
			Foot,
			userNotification,
			userpoints,
			userprofile,
			// userpost,
			// userProfileedit,
			userreplies,
			userwebinar,
		},
		watch: {
			'$store.state.cunyuanyan': {
				handler(newValue, oldValue) {
					// console.log('语言已更新:', newValue);
					this.gudingziduan = this.$store.state.cunyuanyan
					// console.log(this.gudingziduan,'video')
				},
				deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
			}
		},
		created() {

			allUser().then(res => {
				if (res.code === 200) {
					this.wodexiangqing()
				} else {
					this.$cun('yonghuming', '')
					this.$cun('kouling', '')
					this.$alert('Please log in first', '', {
						confirmButtonText: 'Log in',
						confirmButtonClass: 'Loginanniu',
						distinguishCancelAndClose: true,
						center: true,
						roundButton: true,
						beforeClose: (action, instance, done) => {
							if (action === 'confirm') {
								this.$dakai('/login_in')
							} else {
								done();
								this.$dakai('/')
							}
						}
					}).then(action => {
						this.$message({
							type: 'info',
							message: 'action: ' + action
						});
					});
				}
			})

			this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
			this.gudingziduan = this.$store.state.cunyuanyan
			// console.log(this.gudingziduan,'user-Profile')
			this.ptype = this.$route.query.type;
			if (this.ptype >= 0) {
				this.menuindex = this.ptype
			}
		},
		mounted() {

		},
		methods: {
			wodexiangqing() {
				myxiangqing().then(res => {
					console.log(res, 1111)
					if (res.data) {
						this.shu = res.data
						this.colorzu1 = this.$qu('uColor2_' + this.shu.id)
						if (this.colorzu1.length > 0) {
							this.colorzu = this.colorzu1.split(',');
						}
					}

				})
			},
			xuannew(e) {
				this.menuindex = e
			},
			getFirstLetter(name) {
				return name ? name.charAt(0).toUpperCase() : '?'; // 返回第一个字母并转换为大写  
			},
			tuichudenglu() {
				logout().then(s => {
					if (s.message == 'Log out successfully') {
						this.$cun('yonghuming', '')
						this.$cun('kouling', '')
						if (s.data) {
							window.location.href = s.data;
						} else {
							this.$message({
								showClose: true,
								message: s.message,
								type: 'success',
								offset: '350',
								// duration:0
							});
							setTimeout(() => {
								this.$dakai('/')
							}, 1000)
						}
					} else if (s.code == 401) {
						this.$cun('yonghuming', '')
						this.$cun('kouling', '')
					}
				})
			},
			zhangshi(e) {
				if (e != 8 && e > 0) {
					this.menuindex = e
					if (e == 2) {
						this.likeindex = 0
					}
				} else {
					this.menuindex = 2
					this.likeindex = 1
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.zi-E50012 {
		color: #E50012;
	}

	.zi-B7B7B7 {
		color: #B7B7B7;
	}

	.userProfilebox {
		.userProfenge {
			margin: 0 .08rem !important;
		}

		.userProfile {
			position: relative;

			.userProfile-bg {
				background: linear-gradient(182deg, #ff785c 0%, #e70a16 100%);
				height: 1.7rem;
				position: absolute;
				top: 0;
				left: 0;
			}

			.userProfile-Solarland {
				position: relative;
				top: .51rem;
				left: 9%;
				width: 82%;

				.numInfo .Pointss {
					line-height: 1;
					margin-bottom: .05rem;
				}
			}
		}

		.userProfilecontant {
			width: 82%;
			margin: 0 auto;
			margin-top: .8rem;
			padding: 0 0 0.78rem 0;

			.userProfile-leift {
				width: 21.8%;
				height: auto;
				min-width: 220px;

				.userProfile-leift-centen ul li {
					border-bottom: 1px solid #E1E1E1;
					box-sizing: border-box;
				}

				.userProfile-leift-centen ul .active {
					background: #F8F8F8;
					border-bottom: none;
					border-radius: 100px;
				}
			}

			.userProfile-right {
				width: 77%;
				min-height: 7.2rem;
				flex: 1;
				margin-left: 1.5%;

				.userProfile-right-btn {
					display: inline-block;
					padding: .12rem .52rem;
					border-radius: 100px;
					border: 1px solid #e50012;
					box-sizing: border-box;
				}
			}
		}
	}

	.userProfile-right-btn3 {
		display: inline-block;
		padding: .12rem .52rem;
		border-radius: 100px;
		border: 1px solid #e50012;
		box-sizing: border-box;
		color: #fff;
	}

	// ==========================================================================================================================================================================
	// 响应式

	@media screen and (max-width: 767px) {
		.userProfilebox .userProfile .userProfile-Solarland {
			flex-wrap: wrap;
			width: 92%;
			left: 4%;
		}

		.userProfile-Solarland .numInfo {
			margin-top: .3rem;
			padding-right: 0;
			flex-wrap: wrap;
			width: 100%;
			justify-content: center;
		}

		.userProfilebox .userProfilecontant {
			width: 92%;
			left: 4%;
			flex-wrap: wrap;
		}


		.userProfilebox .userProfilecontant .userProfile-leift {
			width: 100%;
		}

		.userProfilebox .userProfilecontant .userProfile-right {
			width: 100%;
			margin-left: 0;
			margin-top: .2rem;
		}
	}
</style>